// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__i3t9Q","buttons":"PendingPaymentAlert_buttons__1QW0X"};